// import { i18n } from 'root/locales';
// import { Gender } from 'root/models';

export const getters = {

};
